import { toast } from "react-toastify";
import { BASE_URL } from "../../global";
import axiosWithToken from "./axiosTokenConfig";

export const submitSiteDelete = async (table, id, type) => {
  const confirmed = window.confirm(
    "Are you sure you want to delete this " + table
  );
  if (!confirmed) return;
  let url = BASE_URL;
  try {
    const idString = (Array.isArray(id) ? id : [id]).join(",");
    const mainDeleteQuery = {
      query: `DELETE FROM ${table} WHERE id IN (${idString});`,
    };
    await axiosWithToken.post(url + `dynamic`, mainDeleteQuery);
    // the 'quotation' table, delete related productDetails
    if (table === "quotation") {
      const productDetailsDeleteQuery = {
        query: `DELETE FROM productDetails WHERE type = 1 AND referenceId IN (${idString});`,
      };
      await axiosWithToken.post(url + `dynamic`, productDetailsDeleteQuery);
    }
    // the 'poAcceptance' table, delete related productDetails
    if (table === "poAcceptance") {
      const productDetailsDeleteQuery = {
        query: `DELETE FROM productDetails WHERE type = 3 AND referenceId IN (${idString});`,
      };
      await axiosWithToken.post(url + `dynamic`, productDetailsDeleteQuery);
    }
    // the 'jobRegister' table, delete related jobRegisterInspection
    if (table === "jobRegister") {
      const productDetailsDeleteQuery = {
        query: `DELETE FROM jobRegisterInspection WHERE jobRegisterId = ${idString};`,
      };
      await axiosWithToken.post(url + `dynamic`, productDetailsDeleteQuery);
    }

    // the 'IR_coverLetter' table, delete related dynamicTableHeader and dynamicTableBody
    if (table === "IR_coverLetter" && type) {
      const headerDeleteQuery = {
        query: `DELETE FROM dynamicTableHeader WHERE type = ${type} AND jobInspectionId IN (${idString});`,
      };
      await axiosWithToken.post(url + `dynamic`, headerDeleteQuery);
      const bodyDeleteQuery = {
        query: `DELETE FROM dynamicTableBody WHERE type = ${type} AND jobInspectionId IN (${idString});`,
      };
      await axiosWithToken.post(url + `dynamic`, bodyDeleteQuery);
    }
    toast("Deleted successfully!");
    setTimeout(() => window.location.reload(false), 1000);
  } catch (err) {
    console.error("Delete error:", err);
  }
};
